import {ACTION} from './constants';
import request from '../../../../utils/request';
import {requestConfig} from "../../../../config/apiResource";
import {showMainLoader, hideMainLoader} from '../../../actions';


export function getContactUsContent(serverData, type='get-in-touch') {
    if(serverData.params){
        if(serverData.params.type)
        type = serverData.params.type;
    }
    return dispatch => {
        return request(requestConfig.getContactUsContent(type))
            .then((json) => {
                type=="get-in-touch" && json && dispatch({ type: ACTION.GET_CONTACT_US_CONTENT , data: json.data }); 
                type=="visit-us" && json && dispatch({ type: ACTION.GET_CONTACT_US_VISIT_US_CONTENT , data: json.data }); 
                type=="investor-relationship-officer" && json && dispatch({ type: ACTION.GET_CONTACT_US_RELATIONSHIP_OFFICER_CONTENT , data: json.data }); 
                type=="stakeholders-information-and-helpdesk" && json && dispatch({ type: ACTION.GET_STAKEHOLDER_INFORMATION_HELPDESK , data: json.data }); 
                
                return json;
            }).catch((error) => {
                console.log("Got Error with about content data: " + error)
            });
    }
}


export function getOfficesFilterList() {
    return dispatch => {
        return request(requestConfig.getOfficesFilterList())
            .then((json) => {
                json && dispatch({ type: ACTION.GET_CONTACT_US_OFFICES_LIST_FILTER , data: json.data });
            }).catch((error) => {
                console.log("Got Error with contact us offices list " + error)
            });
    }
}

export function office(formData) {
    return dispatch => {
            return request(requestConfig.getOfficesList(formData))
                .then((json) => {
                        json && dispatch({ type: ACTION.office_state_city , data: json.data });
                }).catch((error) => {
                        console.log("Got Error with state & city: " + error)
                });
    }
}
export function getChiefInformation() {
    return dispatch => {
        return request(requestConfig.getChiefInformation())
            .then((json) => {
                json && dispatch({ type: ACTION.GET_CHIEF_INFORMATION_CONTENT , data: json.data });
                return json;
            }).catch((error) => {
                console.log("Got Error with chief information " + error)
            });
    }
}
export function getOfficesList(formData) {
    return dispatch => {
        return request(requestConfig.getOfficesList(formData))
            .then((json) => {
                json && dispatch({ type: ACTION.GET_CONTACT_US_OFFICES_LIST , data: json.data });
            }).catch((error) => {
                console.log("Got Error with contact us offices list " + error)
            });
    }
}
